export default __webpack_public_path__ + "static/media/FOTOS_DISCO_08.6209cf85.jpg";